import API from "../../../utils/api";

// Plain JSON — no icon/file upload on a Q&A category (just a title + sort_order), unlike
// Why You'll Love It / Feature Labels above.

export const getQaCategoryApi = async (filters) => {
    const response = await API.get(`settings/qa-category`, { params: filters });
    return { response };
};

export const addQaCategoryApi = async (data) => {
    const response = await API.post(`settings/qa-category`, data);
    return { response };
};

export const updateQaCategoryApi = async (data, id) => {
    const response = await API.post(`settings/qa-category/${id}`, data);
    return { response };
}

export const deleteQaCategoryApi = async (id) => {
    const response = await API.delete(`settings/qa-category/${id}`);
    return { response };
}
